module.exports = __webpack_public_path__ + "static/cs-logo-eb506f891e9104c89e15b1743b0bf29f.png";